/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
import moment from 'moment';
import { getDayMonthWeek, getDayMonth } from './CommonUtils';
import { DIRECT, TRANSFER } from './Constants/GlobalConstants';

// forward --------------------------
// departure ---
export function getForwardDepartureTime(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    const forward = flight.forward[0]; // first flight in a chain
    const time = getDepartureTime(forward);

    if (time.length > 0) {
      result = time;
    } else {
      result = '-/-';
    }
  }

  return result;
}

export function getForwardDepartureDate(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    const forward = flight.forward[0];

    result = getDepartyreDay(forward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getForwardDepartureAirport(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    const forward = flight.forward[0];
    result = getDepartureAirport(forward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getForwardTotalTripTime(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    result = getTotalTripTime(flight.forward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getForwardDepartureAirportId(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    const forward = flight.forward[0];
    result = getDepartureAirportId(forward);
  } else {
    result = '-/-';
  }

  return result;
}
//---

// arrival ---
export function getForwardArrivalTime(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    const forward = flight.forward[flight.forward.length - 1];
    const time = getArrivalTime(forward);

    if (time.length > 0) {
      result = time;
    } else {
      result = '-/-';
    }
  }

  return result;
}

export function getForwardArrivalDate(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    // last in a chain
    const forward = flight.forward[flight.forward.length - 1];
    result = getArrivalDay(forward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getForwardArrivalAirport(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    // last in a chain
    const forward = flight.forward[flight.forward.length - 1];

    result = getArrivalAirport(forward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getForwardArrivalAirportId(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    // last in a chain
    const forward = flight.forward[flight.forward.length - 1];

    result = getArrivalAirportId(forward);
  } else {
    result = '-/-';
  }

  return result;
}

// ---

// common ---
export function getForwardFlight(flight) {
  let result = '';

  if (flight.forward && flight.forward.length > 0) {
    if (flight.forward.length === 1) {
      result = '-/-';
      const forward = flight.forward[0];

      let numberText = '-/-';
      if (forward.number) {
        const { number } = forward;
        numberText = number;
      }

      let companyIdText = '-/-';
      let companyNameText = '-/-';

      if (forward.company) {
        const { company } = forward;

        if (company.id && company.id.length > 0) {
          companyIdText = company.id;
        }

        if (company.name && company.name.length > 0) {
          companyNameText = company.name;
        }
      }

      result = `${numberText}, ${companyIdText} ${companyNameText}`;
    } else {
      const companies = [];
      flight.forward.forEach((e) => {
        if (e.company && e.company.name) {
          if (!companies.includes(e.company.name)) {
            companies.push(e.company.name);
          }
        }
      });

      companies.forEach((e) => {
        if (result.length !== 0) {
          result += ', ';
        }

        result += e;
      });
    }
  }

  return result;
}

export function getForwardCompanies(flight) {
  let result = '';
  if (flight.forward && flight.forward.length > 0) {
    const companies = [];
    flight.forward.forEach((e) => {
      if (e.company && e.company.name) {
        if (!companies.includes(e.company.name)) {
          companies.push(e.company.name);
        }
      }
    });

    companies.forEach((e) => {
      if (result.length !== 0) {
        result += ', ';
      }

      result += e;
    });
  }

  return result;
}

export function getForwardCompaniesWithFlightId(flight) {
  const companies = [];
  if (flight.forward && flight.forward.length > 0) {
    flight.forward.forEach((e) => {
      if (e.company && e.company.name) {
        companies.push({
          company: e.company.name,
          number: e.number,
          plane: e.plane,
        });
      }
    });
  }

  return companies;
}

// ---

// backward --------------
// departure ---
export function getBackwardDepartureTime(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    const backward = flight.backward[0];
    const time = getDepartureTime(backward);

    if (time.length > 0) {
      result = time;
    } else {
      result = '-/-';
    }
  }

  return result;
}

export function getBackwardDepartureDate(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    const backward = flight.backward[0];
    result = getDepartyreDay(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardDepartureAirport(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    const backward = flight.backward[0];

    result = getDepartureAirport(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardDepartureAirportId(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    const backward = flight.backward[0];

    result = getDepartureAirportId(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardTotalTripTime(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    result = getTotalTripTime(flight.backward);
  } else {
    result = '-/-';
  }

  return result;
}
// ---

// arrival ---
export function getBackwardArrivalTime(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    const backward = flight.backward[flight.backward.length - 1];
    const time = getArrivalTime(backward);

    if (time.length > 0) {
      result = time;
    } else {
      result = '-/-';
    }
  }

  return result;
}

export function getBackwardArrivalDate(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    // last in a chain
    const backward = flight.backward[flight.backward.length - 1];
    result = getArrivalDay(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardArrivalAirport(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    // last in a chain
    const backward = flight.backward[flight.backward.length - 1];
    result = getArrivalAirport(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardArrivalAirportId(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    // last in a chain
    const backward = flight.backward[flight.backward.length - 1];
    result = getArrivalAirportId(backward);
  } else {
    result = '-/-';
  }

  return result;
}

export function getBackwardCompanies(flight) {
  let result = '';
  if (flight.backward && flight.backward.length > 0) {
    const companies = [];
    flight.backward.forEach((e) => {
      if (e.company && e.company.name) {
        if (!companies.includes(e.company.name)) {
          companies.push(e.company.name);
        }
      }
    });

    companies.forEach((e) => {
      if (result.length !== 0) {
        result += ', ';
      }

      result += e;
    });
  }

  return result;
}

export function getBackwardCompaniesWithFlightId(flight) {
  const companies = [];
  if (flight.backward && flight.backward.length > 0) {
    flight.backward.forEach((e) => {
      if (e.company && e.company.name) {
        companies.push({
          company: e.company.name,
          number: e.number,
          plane: e.plane,
        });
      }
    });
  }

  return companies;
}

export function getBackwardFlight(flight) {
  let result = '';

  if (flight.backward && flight.backward.length > 0) {
    if (flight.backward.length === 1) {
      result = '-/-';
      const backward = flight.backward[0];

      let numberText = '-/-';
      if (backward.number) {
        const { number } = backward;
        numberText = number;
      }

      let companyIdText = '-/-';
      let companyNameText = '-/-';

      if (backward.company) {
        const { company } = backward;

        if (company.id && company.id.length > 0) {
          companyIdText = company.id;
        }

        if (company.name && company.name.length > 0) {
          companyNameText = company.name;
        }
      }

      result = `${numberText}, ${companyIdText} ${companyNameText}`;
    } else {
      const companies = [];
      flight.backward.forEach((e) => {
        if (e.company && e.company.name) {
          if (!companies.includes(e.company.name)) {
            companies.push(e.company.name);
          }
        }
      });

      companies.forEach((e) => {
        if (result.length !== 0) {
          result += ', ';
        }

        result += e;
      });
    }
  }

  return result;
}

// departure ----
export function getDepartureTime(flight) {
  let result = '-/-';

  if (flight.departure && flight.departure.time) {
    result = flight.departure.time.split(' ')[0]; // remove +1
  }

  return result;
}

export function getDepartyreDay(flight) {
  let result = '-/-';

  if (flight.departure && flight.departure.date) {
    result = getDayMonthWeek(flight.departure.date);
  }

  return result;
}

export function getDepartureAirport(flight) {
  let result = '-/-';
  if (flight.departure && flight.departure.port) {
    const { port } = flight.departure;
    result = `${port.shortName ? port.shortName : '-/-'}`;
  }

  return result;
}

export function getDepartureAirportId(flight) {
  let result = '-/-';
  if (flight.departure && flight.departure.port) {
    const { port } = flight.departure;
    result = `${port.id ? port.id : '-/-'}`;
  }

  return result;
}

export function getDeparturePortName(flight) {
  let result = '-/-';

  if (flight && flight.departure) {
    if (flight.departure.port) {
      const { port } = flight.departure;
      result = port.name;
    }
  }

  return result;
}
//---

// arrival ---
export function getArrivalTime(flight) {
  let result = '-/-';

  if (flight.arrival && flight.arrival.time) {
    result = flight.arrival.time.split(' ')[0]; // removing +1
  }

  return result;
}

export function getArrivalDay(flight) {
  let result = '-/-';

  if (flight.arrival.date) {
    result = getDayMonthWeek(flight.arrival.date);
  }

  return result;
}

export function getArrivalAirport(flight) {
  let result = '-/-';
  if (flight.arrival && flight.arrival.port) {
    const { port } = flight.arrival;
    result = `${port.shortName ? port.shortName : '-/-'}`;
  }

  return result;
}

export function getArrivalAirportId(flight) {
  let result = '-/-';
  if (flight.arrival && flight.arrival.port) {
    const { port } = flight.arrival;
    result = `${port.id ? port.id : '-/-'}`;
  }

  return result;
}

export function getArrivalPortName(flight) {
  let result = '-/-';

  if (flight && flight.arrival) {
    if (flight.arrival.port) {
      const { port } = flight.arrival;
      result = port.name;
    }
  }

  return result;
}
// ---

// ------------------------------
export function getTransferTime(flights, index) {
  let result = '-/-';

  if (flights.length > 1 && index < flights.length - 1) {
    const flightArr = flights[index];
    const flightDep = flights[index + 1];

    if (flightDep.departure && flightArr.arrival) {
      const departMoment = `${flightDep.departure.date} ${flightDep.departure.time}`;
      const transferDepart = moment(departMoment, 'DD.MM.YYYY HH:mm');

      const arrivalMoment = `${flightArr.arrival.date} ${flightArr.arrival.time}`;
      const transferArr = moment(arrivalMoment, 'DD.MM.YYYY HH:mm');

      const duration = moment.duration(transferDepart.diff(transferArr));

      result = `Пересадка ${duration.hours()}ч ${duration.minutes()}м`;
    }
  }

  return result;
}

export function getForwardTransfer(flight) {
  let result = '-/-';

  if (flight.forward && flight.forward.length > 0) {
    if (flight.forward.length <= 1) {
      result = DIRECT;
    } else {
      const transferText = `${TRANSFER} ${getTripTransferSummary(
        flight.forward,
      )}`;

      result = transferText;
    }
  }

  return result;
}

export function getBackwardTransfer(flight) {
  let result = '-/-';

  if (flight.backward && flight.backward.length > 0) {
    if (flight.backward.length <= 1) {
      result = DIRECT;
    } else {
      const transferText = `${TRANSFER} ${getTripTransferSummary(
        flight.backward,
      )}`;

      result = transferText;
    }
  }

  return result;
}

export function getTripTransferSummary(flights) {
  let transferText = '';
  for (let i = 0; i < flights.length - 1; i++) {
    const transferPortId = flights[i].arrival.port.id;

    const departMoment = `${flights[i + 1].departure.date} ${
      flights[i + 1].departure.time
    }`;

    const transferDepart = moment(departMoment, 'DD.MM.YYYY HH:mm');

    const arrivalMoment = `${flights[i].arrival.date} ${flights[i].arrival.time}`;

    const transferArr = moment(arrivalMoment, 'DD.MM.YYYY HH:mm');

    const duration = moment.duration(transferDepart.diff(transferArr));

    const transferTime = `(${duration.hours()}ч ${duration.minutes()}м)`;

    transferText += `${transferPortId} ${transferTime}`;

    if (i + 1 < flights.length - 1) {
      transferText += ', ';
    }
  }

  return transferText;
}

export function getFlightCompanyName(flight) {
  let result = '-/-';

  if (flight && flight.company && flight.company.name) {
    result = flight.company.name;
  }

  return result;
}

export function getTimeInAir(flight) {
  let result = '-/-';

  if (flight.departure && flight.arrival) {
    if (
      flight.departure.port &&
      flight.arrival.port &&
      flight.departure.port.timeZone &&
      flight.arrival.port.timeZone
    ) {
      const arrUtc = getUtcOffset(flight.arrival.port.timeZone);
      const depUtc = getUtcOffset(flight.departure.port.timeZone);

      if (arrUtc && depUtc) {
        const arrTime = flight.arrival.time.split(' ')[0];
        const arrival = moment(
          `${flight.arrival.date} ${arrTime}`,
          'DD.MM.YYYY HH:mm',
        ).utcOffset(arrUtc, true);

        const depTime = flight.departure.time.split(' ')[0];

        const departure = moment(
          `${flight.departure.date} ${depTime}`,
          'DD.MM.YYYY HH:mm',
        ).utcOffset(depUtc, true);

        const duration = moment.duration(arrival.diff(departure, 'minute'));
        result = `В пути: ${Math.floor(duration / 60)}ч ${duration % 60}мин`;
      }
    }
  }

  return result;
}

export function getFlightPrice(flight) {
  let result = '-/-';

  if (flight.price) {
    const { currency, value } = flight.price;
    result = `${value} ${currency}`;
  }

  return result;
}

export function getTotalTripTime(flights) {
  let result = '-/-';

  if (flights && flights.length > 0) {
    const departure = flights[0].departure;
    const arrival = flights[flights.length - 1].arrival;

    if (departure && arrival) {
      if (
        arrival.port &&
        arrival.port.timeZone &&
        departure.port &&
        departure.port.timeZone
      ) {
        const arrUtc = getUtcOffset(arrival.port.timeZone);
        const depUtc = getUtcOffset(departure.port.timeZone);

        if (arrUtc && depUtc) {
          const arrTime = arrival.time.split(' ')[0];
          const arrMoment = moment(
            `${arrival.date} ${arrTime}`,
            'DD.MM.YYYY HH:mm',
          ).utcOffset(arrUtc, true);

          const depTime = departure.time.split(' ')[0];

          const depMoment = moment(
            `${departure.date} ${depTime}`,
            'DD.MM.YYYY HH:mm',
          ).utcOffset(depUtc, true);

          const duration = moment.duration(arrMoment.diff(depMoment, 'minute'));
          result = `${Math.floor(duration / 60)}ч ${duration % 60}мин`;
        }
      }
    }
  }

  return result;
}

export function getTripStages(flights) {
  const result = [];

  if (flights.length === 2) {
    // first flight time
    const firstFlightTime = getPeriodMins(
      flights[0].departure,
      flights[0].arrival,
    );

    // transfer time
    const transferTime = getPeriodMins(
      flights[0].arrival,
      flights[1].departure,
    );

    // second flight time
    const secondFlightTime = getPeriodMins(
      flights[1].departure,
      flights[1].arrival,
    );

    const totalTime = firstFlightTime + transferTime + secondFlightTime;

    result.push({
      percent: Math.ceil((firstFlightTime / totalTime) * 100),
      isFlight: true,
    });

    result.push({
      percent: Math.ceil((transferTime / totalTime) * 100),
      isFlight: false,
    });

    result.push({
      percent: Math.ceil((secondFlightTime / totalTime) * 100),
      isFlight: true,
    });
  } else if (flights.length === 3) {
    // first flight time
    const firstFlightTime = getPeriodMins(
      flights[0].departure,
      flights[0].arrival,
    );

    // transfer time
    const transferTime = getPeriodMins(
      flights[0].arrival,
      flights[1].departure,
    );

    // second flight time
    const secondFlightTime = getPeriodMins(
      flights[1].departure,
      flights[1].arrival,
    );

    // second transfer
    const secondTransferTime = getPeriodMins(
      flights[1].arrival,
      flights[2].departure,
    );

    // second flight time
    const thirdFlightTime = getPeriodMins(
      flights[2].departure,
      flights[2].arrival,
    );

    const totalTime =
      firstFlightTime +
      transferTime +
      secondFlightTime +
      secondTransferTime +
      thirdFlightTime;

    result.push({
      percent: Math.ceil((firstFlightTime / totalTime) * 100),
      isFlight: true,
    });

    result.push({
      percent: Math.ceil((transferTime / totalTime) * 100),
      isFlight: false,
    });

    result.push({
      percent: Math.ceil((secondFlightTime / totalTime) * 100),
      isFlight: true,
    });

    result.push({
      percent: Math.ceil((secondTransferTime / totalTime) * 100),
      isFlight: false,
    });

    result.push({
      percent: Math.ceil((thirdFlightTime / totalTime) * 100),
      isFlight: true,
    });
  }

  return result;
}

export function getPeriodMins(departure, arrival) {
  let result = 0;

  if (departure && arrival) {
    if (
      departure.port &&
      departure.port.timeZone &&
      arrival.port &&
      arrival.port.timeZone
    ) {
      const depUtc = getUtcOffset(departure.port.timeZone);
      const arrUtc = getUtcOffset(arrival.port.timeZone);

      if (depUtc && arrUtc) {
        const arrTime = arrival.time.split(' ')[0];
        const arrMoment = moment(
          `${arrival.date} ${arrTime}`,
          'DD.MM.YYYY HH:mm',
        ).utcOffset(arrUtc, true);

        const depTime = departure.time.split(' ')[0];
        const depMoment = moment(
          `${departure.date} ${depTime}`,
          'DD.MM.YYYY HH:mm',
        ).utcOffset(depUtc, true);

        result = arrMoment.diff(depMoment, 'minute');
      }
    }
  }

  return result;
}

export function getUtcOffset(timeZone) {
  let result = null;
  if (timeZone && timeZone.length > 0) {
    const time = timeZone.substring(1);
    const timeArr = time.split(':');

    let h;
    let m;
    if (timeArr.length === 2) {
      if (timeArr[0].charAt(0) === '0') {
        h = timeArr[0].charAt(1);
      } else {
        h = timeArr[0];
      }

      if (timeArr[1].charAt(0) === '0') {
        m = timeArr[1].charAt(1);
      } else {
        h = timeArr[1];
      }

      result = parseFloat(`${h}.${m}`);
    }
  }

  return result;
}

export function getFlightToText(flight) {
  const to = [];

  if (flight && flight.forward) {
    flight.forward.forEach((e) => {
      to.push(
        `${e.departure.time} ${getDayMonth(e.departure.date)} ${
          e.departure.port.id
        } - ${e.arrival.time} ${getDayMonth(e.arrival.date)} ${
          e.arrival.port.id
        }, ${e.number} ${e.company.name}`,
      );
    });
  }

  return to;
}

export function getFlightBackText(flight) {
  const back = [];

  if (flight && flight.backward) {
    flight.backward.forEach((e) => {
      back.push(
        `${e.departure.time} ${getDayMonth(e.departure.date)} ${
          e.departure.port.id
        } - ${e.arrival.time} ${getDayMonth(e.arrival.date)} ${
          e.arrival.port.id
        }, ${e.number} ${e.company.name}`,
      );
    });
  }

  return back;
}

export function isCheapestFlight(selected, flights) {
  if (flights.length <= 1) {
    return false;
  } else {
    let cheapestPrice;
    let isPriceInited = false;

    flights.forEach((e) => {
      if (e.price && e.price.value) {
        if (!isPriceInited) {
          cheapestPrice = e.price.value;
          isPriceInited = true;
        }

        if (e.price.value < cheapestPrice) {
          cheapestPrice = e.price.value;
        }
      }
    });

    if (selected.price.value === cheapestPrice) {
      const theSamePriceQuantity = flights.filter(
        (e) => e.price.value === cheapestPrice,
      ).length;

      if (flights.length !== theSamePriceQuantity) {
        return true;
      }

      return false;
    }

    return false;
  }
}

// "23:50 15 ноя. MSQ" or "08:20 +1 16 ноя. DXB"
function parseFlightPoint(text) {
  const parts = text.trim().split(' ');

  if (parts.length < 3) {
    return null;
  }

  const time = parts.shift();
  const dayShift = parts[0].startsWith('+') ? parts.shift() : '';
  const port = parts.pop();

  return { time, dayShift, date: parts.join(' '), port };
}

// parses a segment line built by getFlightToText / getFlightBackText
export function parseFlightText(text) {
  if (!text) {
    return null;
  }

  const commaIndex = text.indexOf(', ');
  const route = commaIndex >= 0 ? text.substring(0, commaIndex) : text;
  const flightInfo = commaIndex >= 0 ? text.substring(commaIndex + 2) : '';
  const [from, to] = route.split(' - ');
  const departure = from ? parseFlightPoint(from) : null;
  const arrival = to ? parseFlightPoint(to) : null;

  if (!departure || !arrival) {
    return null;
  }

  const infoParts = flightInfo.split(' ');

  return {
    departure,
    arrival,
    number: infoParts[0] || '',
    company: infoParts.slice(1).join(' '),
  };
}

// flight choice: admin actualization and the user cabinet -------------------

export function isFlightValid(flight) {
  return !!flight && !!flight.price && !!flight.price.value;
}

export function getCheapestFlightPrice(flights) {
  return Math.min(...flights.map((flight) => flight.price.value));
}

// same choice as on the order details page,
// without a default flight the cheapest one
export function getDefaultFlight(flights) {
  const defaultFlight = flights.find((flight) => flight.isdefault === true);

  if (defaultFlight) {
    return defaultFlight;
  }

  const cheapestPrice = getCheapestFlightPrice(flights);

  return flights.find((flight) => flight.price.value === cheapestPrice);
}

// the order keeps the flight only as text lines
export function isOrderFlight(order, flight) {
  return (
    `${order.toTrip || []}` === `${getFlightToText(flight)}` &&
    `${order.backTrip || []}` === `${getFlightBackText(flight)}`
  );
}
